
import { useLocation, useNavigate, useParams } from "react-router-dom"
import DashboardNavItem from "../../../components/DashboardNavItem/DashboardNavItem";
import { ValidatorPage } from '../../../components/CreatePayment/ExcelValidatorTool';
import { TooltipProvider } from '../../../components/CreatePayment/ExcelValidatorTool/components/tooltip';
import DashboardComponentWrapper from '../../../components/DashboardComponentWrapper';
import { icons } from '../../../assets';
import { useAppSelector } from "../../../app/hooks";

const ExcelValidator = () => {
  // const user = useAppSelector((state) => state.auth.user);

  const navigate = useNavigate();
  const navItems: Record<string, any>[] = [
    {
      label: 'Go back',
      action: () => navigate(-1),
      bgColor: '#0898A0',
      img: icons.closeNav,
    },
  ];

    const renderNavItems = () => {
    return (
      <DashboardNavItem
        navItems={[]}
        tab={''}
        setTab={() => { }}
        navItemsObj={navItems}
      />
    )
  }

  return (
    <TooltipProvider>
      <DashboardComponentWrapper
        title="Schedule Validator"
        pageDetails="Upload and validate your pension schedule files."
        renderNavItems={renderNavItems}
      >
        <ValidatorPage />
      </DashboardComponentWrapper>
    </TooltipProvider>
  );
};

export default ExcelValidator;
